import React from 'react';
import { Button, Form, FormGroup, Input, InputGroup, Label } from 'reactstrap'

const AchForm = (props) => {
    return (
        <Form onSubmit={props.onSubmit} className="noprint">
            <FormGroup>
                <div className="text-left">
                    <Label>Account Holder Name<span className='error-span'>*</span></Label>
                    <InputGroup>
                        <Input name="account_holder_name" type="text" placeholder='Account Holder Name' maxLength={25} required pattern="[A-Za-z ]+" title="Name must have characters only"/>
                    </InputGroup>
                </div><br />
                <div className="text-left">
                    <Label>Account Number<span className='error-span'>*</span></Label>
                    <InputGroup>
                        <Input name="account_number" type="text" placeholder='000123456789' maxLength={20} required pattern="\d*" title="Account number must have positive numbers only" />
                    </InputGroup>
                </div><br />
                <div className="text-left">
                    <Label>Routing Number<span className='error-span'>*</span></Label>
                    <InputGroup>
                        <Input name="routing_number" type="text" placeholder='110000000' maxLength={10} required pattern="[0-9]{9}" title="Routing number must have 9 digits" />
                    </InputGroup>
                </div><br />
                <div className="text-left">
                    <Label>Account Type</Label>
                    <InputGroup>
                        <Input type="select" name="account_type"
                        //onChange={(evt) => this.setState({ accountType: evt.target.value })}
                        >
                            <option value='individual'>&ensp;Individual</option>
                            <option value='company'>&ensp;Company</option>
                        </Input>
                    </InputGroup>
                </div><br />
                <div className="text-left">
                    <Label>Amount</Label>
                    <InputGroup>
                        <Input type="text" value={'$ ' + props.amount} readOnly />
                    </InputGroup>
                </div><br />
                <div className="text-left hidden">
                    <Label>Description<span className='error-span'>*</span></Label>
                    <InputGroup>
                        <Input name="description" type="text" placeholder='Example customer' maxLength={50} required />
                    </InputGroup>
                </div><br />
            </FormGroup>
            <Button color="primary">Pay</Button>&nbsp;&nbsp;
        </Form>
    );
};
export default AchForm;


// WEBPACK FOOTER //
// ./src/components/ui/AchForm.js